export function DefaultColumnFilter({ column: { filterValue, preFilteredRows, setFilter } }) {
  return (
    <input
      size='sm'
      className='mb-3 mt-3'
      value={filterValue || ""}
      aria-label='Small'
      aria-describedby='inputGroup-sizing-sm'
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ...`}
    />
  );
}
